/**
 * @module app.bdc.reports.simulationCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SimulationCtrl($scope, $rootScope, pricesService, goodwillGesturesService, orderService) {
        var self = {};

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('bdc/list');
        }

        self.user = $rootScope.user;
        self.order = $rootScope.order;

        self.goodwillGesturesService = goodwillGesturesService;
        self.orderService = orderService;

        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);
        self.getContractTypeValue = pricesService.getContractTypeValue;

        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        self.isUpsOnly =  self.order.goodwillGestures && self.order.goodwillGestures.scanupServices.isUPS && !self.order.goodwillGestures.scanupServices.isBrinks

        /**
         * Get total prices for : till, tillSoftware, cashdrawers, tillaccessories and maintenance.
         * @return {Object} {rental:<rental total price>, purchase: <purchase total price>}
         */
        function getTillPrices() {
            var rental = 0,
                purchase = 0;

            if (self.order.contract.contractType.code === 'ACHAT') {
                purchase +=
                    self.order.prices.till +
                    self.order.prices.tillSoftware +
                    self.order.prices.cashDrawers +
                    self.order.prices.tillAccessories;
            }
            else {
                rental +=
                    self.order.prices.till +
                    self.order.prices.tillSoftware +
                    self.order.prices.cashDrawers +
                    self.order.prices.tillAccessories;
            }

            rental +=
                self.order.prices.maintenanceTill +
                self.order.prices.sav +
                self.order.prices.warrantyExtension +
                self.order.prices.insurance +
                self.order.prices.softwareServices +
                self.order.prices.packBoulangerie +
                self.order.prices.gestion;

            return {
                rental: rental,
                purchase: purchase
            };
        }

        /**
         * Sum option's prices according to
         * @method getOptionPrices
         * @return {Object} prices rental and purchase prices for all options.
         */
        function getOptionPrices() {
            var prices = { rental: 0, purchase: 0 };

            var scanupPurchase =
                self.order.scanupContractType.code === 'ACHAT'
                    ? self.order.prices.scanup + self.order.prices.scanupOptions
                    : 0;
            var scanupRental =
                self.order.scanupContractType.code === 'ACHAT'
                    ? 0
                    : self.order.prices.scanup + self.order.prices.scanupOptions;

            let installPurchase = self.order.installContractType.code === 'ACHAT'
                ? self.order.prices.prestationInstallation
                : 0;
            let installRental =
                self.order.installContractType.code === 'ACHAT'
                    ? 0
                    : self.order.prices.prestationInstallation;

            let cateringSupportPurchase = self.order.cateringSupportContractType.code === 'ACHAT'
                ? self.order.prices.prestationCateringSupport
                : 0;
            let cateringSupportRental =
                self.order.cateringSupportContractType.code === 'ACHAT'
                    ? 0
                    : self.order.prices.prestationCateringSupport;


            var flashupPurchase = self.order.flashupContractType.code === 'ACHAT' ? self.order.prices.flashup : 0;
            var flashupRental = self.order.flashupContractType.code === 'ACHAT' ? 0 : self.order.prices.flashup;

            prices.rental +=
                scanupRental +
                installRental +
                cateringSupportRental +
                flashupRental +
                self.order.prices.tpe +
                self.order.prices.BBoosterOptions +
                self.order.prices.scanupBimediaPayOptions;
            prices.purchase +=
                scanupPurchase +
                installPurchase +
                cateringSupportPurchase +
                flashupPurchase +
                self.order.prices.tpeOptions +
                self.order.prices.servicesNAP +
                self.order.prices.activateBBoosterOptions;

            if (self.order.contract.contractType.code === 'ACHAT') {
                prices.purchase += self.order.prices.tabletAndPC + self.order.prices.printerPurchase;
            }
            else {
                prices.rental += self.order.prices.tabletAndPC + self.order.prices.printerRental;
            }
            return prices;
        }

        /**
         * Get revenue price
         * @return {number}
         */
        function getRevenue() {
            return self.order.goodwillGestures && self.order.goodwillGestures.revenue.rateValue
                ? self.order.goodwillGestures.revenue.rateValue
                : 0;
        }

        function getWelcomeBonus() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.welcomeBonus
                ? self.order.goodwillGestures.amount.welcomeBonus
                : 0;
        }

        /**
         * Get deloitte price
         * @return {number}
         */
        function getDeloitte() {
            if (self.order.isDeloitte) {
                if (self.order.contract.contractType.code === 'ACHAT') {
                    return self.order.prices.deloitteTotal;
                }
                return self.order.prices.deloitteMonthly;
            }
            return 0;
        }

        function getCashinServices() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.cashinServices
                ? goodwillGesturesService.CASHIN_SERVICES_MONTHLY_AMOUNT
                : 0;
        }

        function getServicesFestival() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.servicesFestival
                ? goodwillGesturesService.SERVICES_FESTIVAL_MONTHLY_AMOUNT
                : 0;
        }

        function getEagle() {
            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.eagle){
                if(self.order.contract.contractType.code === 'ACHAT') {
                    return self.order.goodwillGestures.amount.eagle / 48;
                }
                return self.order.goodwillGestures.amount.eagle / self.getContractTypeValue();
            }
            return 0;
        }

        function getLaunchBimediaPay() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBimediaPay
                ? goodwillGesturesService.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT
                : 0;
        }

        function getMonthlyLaunchBimediaPay() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBimediaPay ? 12 : 0;
        }

        function getLaunchBBooster() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBBooster
                ? goodwillGesturesService.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT
                : 0;
        }

        function getActivateBBooster() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBBooster ? 75 : 0;
        }

        function getMoneyTransferServices() {
            return self.order.goodwillGestures && self.order.goodwillGestures.moneyTransfer.enabled
                ? goodwillGesturesService.getMoneyTransferMonthlyPrice(self.order)
                : 0;
        }

        function getScanupServices() {
            if (self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupServices) {
                if (self.order.contract.contractType.code === 'LOC60') {
                    return goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT_60;
                }
                return goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT;
            }
            return 0;
        }
        function getAchatScanupServices() {
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupServices
                ? goodwillGesturesService.SCANUP_SERVICES_TOTAL
                : 0;
        }

        function getFullPremiumOffer(){
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.fullPremiumOffer ? self.order.goodwillGestures.amount.fullPremiumOffer : 0;
        }

        function getExceptionalOffer(){
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.exceptionalOffer ? self.order.goodwillGestures.amount.exceptionalOffer : 0;
        }

        function getBgreenOffer(){
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.bgreenOffer ? self.order.goodwillGestures.amount.bgreenOffer : 0;
        }

        function getQuickInstallOffer(){
            return self.order.goodwillGestures && self.order.goodwillGestures.amount.quickInstall ? self.order.goodwillGestures.amount.quickInstall : 0;
        }

        function getTotal() {
            var total = { rental: 0, purchase: 0 };

            total.rental =
                getTillPrices().rental +
                self.order.prices.reintegration +
                getOptionPrices().rental -
                getRevenue() -
                getCashinServices() -
                getServicesFestival() -
                getMoneyTransferServices() -
                getMonthlyLaunchBimediaPay() -
                getLaunchBBooster() -
                getEagle() -
                getExceptionalOffer() -
                getFullPremiumOffer() -
                getBgreenOffer() -
                getQuickInstallOffer();
            total.purchase =
                getTillPrices().purchase + getOptionPrices().purchase - getWelcomeBonus() - getActivateBBooster();

            if (self.order.contract.contractType.code === 'ACHAT') {
                total.purchase -= getDeloitte();
                total.purchase -= getLaunchBimediaPay();
                total.purchase -= getAchatScanupServices() -
                    getExceptionalOffer() -
                    getFullPremiumOffer();
            }
            else {
                total.rental -= getDeloitte();
                total.rental -= getLaunchBimediaPay();
                total.rental -= getScanupServices();
            }

            return total;
        }

        function getTotalLabel() {
            var res = 'TOTAL';
            if (self.order.isDeloitte && self.order.goodwillGestures && self.order.goodwillGestures.revenue.rateValue) {
                res +=
                    ' lissé après déduction ' +
                    (self.order.contract.scenarioType.code === 'CONQUETE' ? 'stimulateur' : 'accélérateur') +
                    ' de revenus et subvention Deloitte';
                return res;
            }

            if (self.order.isDeloitte) {
                res += ' lissé après déduction subvention Deloitte';
                return res;
            }

            if (self.order.goodwillGestures && self.order.goodwillGestures.revenue.rateValue) {
                res +=
                    ' lissé après déduction ' +
                    (self.order.contract.scenarioType.code === 'CONQUETE' ? 'stimulateur' : 'accélérateur') +
                    ' de revenus';
                return res;
            }

            return res;
        }

        // init
        self.tills = getTillPrices();
        self.revenue = getRevenue();
        self.welcomeBonus = getWelcomeBonus();
        self.deloitte = getDeloitte();
        self.optionPrices = getOptionPrices();
        self.cashinServices = getCashinServices();
        self.servicesFestival = getServicesFestival();
        self.launchBimediaPay = getLaunchBimediaPay();
        self.monthlyLaunchBimediaPay = getMonthlyLaunchBimediaPay();
        self.launchBBooster = getLaunchBBooster();
        self.activateBBooster = getActivateBBooster();
        self.moneyTransferServices = getMoneyTransferServices();
        self.scanupServices = self.order.contract.contractType.code === 'ACHAT' ? getAchatScanupServices() : getScanupServices();
        self.eagle = getEagle();
        self.exceptionalOffer = getExceptionalOffer();
        self.bgreenOffer = getBgreenOffer();
        self.fullPremiumOffer = getFullPremiumOffer();
        self.quickInstallOffer = getQuickInstallOffer();
        self.total = getTotal();
        self.totalLabel = getTotalLabel();

        return self;
    }

    SimulationCtrl.$inject = ['$scope', '$rootScope', 'pricesService', 'goodwillGesturesService', 'orderService'];

    angular.module('app.bdc.reports.simulationCtrl', []).controller('SimulationCtrl', SimulationCtrl);
});
